export const Titles = {
    module: "Module List",
    daycare: "Daycare List",
    subscription: "Subscription Plan",
    payment: "Payment History",
    enquiry: "Enquiry List",
    relation: "Relation List",
    category: "Category List",
    cms: "Content Management System",

}